module.exports = __webpack_public_path__ + "static/media/Plus.03233364.svg";